import styled from 'styled-components/macro';
import TeamBlock from '../TeamBlock';

export const ContainerTeamContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TeamLocalBlock = styled(TeamBlock)``;

export const TeamVisitorBlock = styled(TeamBlock)``;

export const TeamBlockContent = styled.div`
  display: grid;
  min-height: 100%;
  grid-template-rows: auto auto;
  ${({ tabMode }) =>
    !tabMode
      ? `
    position: absolute;
    top: 0px;
    width: 100%;
    min-height: 100%;
  `
      : null}
`;

export const Season = styled.span`
  text-transform: uppercase;
  margin-right: 5px;
`;

export const TeamSeasonLabel = styled.span`
  display: block;
  text-transform: uppercase;
  font-size: 9px;
  margin-bottom: 5px;
  font-family: ${({ theme }) => theme.primaryFontLight};
`;
export const TeamSeason = styled.span`
  display: block;
  font-size: 13px;
  font-family: ${({ theme }) => theme.primaryFontBold};
`;
